export const LIST_PAGES = ["stories", "ads", "search-ads", "drug-materials", "cmes", "tools"];
